export const CLIENT_PLATFORM = "web" as const;

export const CLIENT_VERSION =
  (import.meta.env.VITE_APP_VERSION as string | undefined) || "1.0.0";

export const CLIENT_ENVIRONMENT = (
  (import.meta.env.VITE_APP_ENVIRONMENT as string | undefined) ||
  (import.meta.env.MODE === "production" ? "production" : "development")
) as "development" | "production";

export const CLIENT_VERSION_HEADERS = {
  "x-client-platform": CLIENT_PLATFORM,
  "x-client-version": CLIENT_VERSION,
  "x-client-environment": CLIENT_ENVIRONMENT,
} as const;
